import React from 'react';
import './logoHolder.css'

function C2wLogoHolder( { imgSvg } ) {
  return (
    <div className='C2wLogoHolder'>
        <img src={`/assets/images/landing/${imgSvg}.svg`} alt='tech-logo'  />
    </div>
  )
}

export default C2wLogoHolder
